import { Route, Routes } from 'react-router-dom';

import Home from './pages/Home';
import Login from './pages/Login';
import Blog from './pages/Blog';
import Vision from './pages/Vision';
import Pantry from './pages/Pantry';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import RecipeSearch from './pages/RecipeSearch';
import RecipeView from './pages/RecipeView';
import AdminPanel from './components/admin/AdminPanel';
import UnitPanel from './components/admin/Units';
import ProtectedRoute from './components/ProtectedRoute';

function Body() {
  return (
    <div className="main container">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recipes" element={<RecipeSearch />} />
        <Route path="/recipes/:id" element={<RecipeView />} />
        <Route path="/admin" element={<ProtectedRoute element={<AdminPanel />} />} />
        <Route path="/admin/units" element={<ProtectedRoute element={<UnitPanel />} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/pantry" element={<Pantry />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default Body;
